import Institution from "@/pages/administrer/configuration/institutions/Institution.vue";
import CreateInstitution from "@/pages/administrer/configuration/institutions/CreateInstitution.vue";
import ShowInstitution from "@/pages/administrer/configuration/institutions/ShowInstitution.vue"


export default [{
    path: 'institutions',
    meta: { permissions: ["view_institution"] },
    props: true,
    name: "AdminConfigInstitution",
    component: Institution
},
{
    path: 'institutions/create',
    meta: { permissions: ["create_institution"] },
    name: "AdminConfigCreateInstitution",
    component: CreateInstitution
},
{
    path: 'institutions/:id/show',
    meta: { permissions: ["view_any_institution"] },
    name: "AdminConfigShowInstitution",
    component: ShowInstitution
}]